exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal_head {\r\n    padding: 0px !important;\r\n}\r\n\r\n\r\n.modal-header .close {\r\n    font-size:22px;\r\n    opacity: 0.8;\r\n    color: #fff;\r\n    padding:5px 5px;\r\n}\r\n.modal-header .close:hover {  \r\n    opacity: 1;\r\n}\r\n\r\n.modal_head h4{\r\nbackground-color: #ddd !important;\r\n    border-radius: 5px !important;\r\n    padding: 0px 5px !important;\r\n\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/shared/modeldialog/template/modal-header.css
// module id = 539
// module chunks = 3